import React from "react";

interface StatCardProps {
  value: string;
  label: string;
}

/**
 * Glanceable metric used in the homepage impact band.
 * Big tabular number + concise label — the fastest credibility signal for recruiters.
 */
const StatCard: React.FC<StatCardProps> = ({ value, label }) => (
  <div className="flex flex-col items-center text-center px-4 py-6">
    <span className="text-4xl md:text-5xl font-bold tracking-tight tabular-nums text-primary-600 dark:text-primary-400">
      {value}
    </span>
    <span className="mt-2 text-sm font-medium text-gray-600 dark:text-gray-400 leading-snug">
      {label}
    </span>
  </div>
);

export default StatCard;
